import React from "react";
import "./We.css";

const We = () => {
  return (
    <div className="we-container">
      <div className="we-swim">
        <h2 className="we-heading">WE SWIM.</h2>
        <p className="we-info">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Saepe
          quibusdam maiores harum quod possimus nam quasi, vitae repudiandae
          voluptas veniam fugit neque beatae maxime, velit delectus repellat ab
          laudantium hic?
        </p>
      </div>
      <div className="we-bike">
        <h2 className="we-heading">WE BIKE.</h2>
        <p className="we-info">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Saepe
          quibusdam maiores harum quod possimus nam quasi, vitae repudiandae
          voluptas veniam fugit neque beatae maxime, velit delectus repellat ab
          laudantium hic?
        </p>
      </div>
      <div className="we-run">
        <h2 className="we-heading">WE RUN.</h2>
        <p className="we-info">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Saepe
          quibusdam maiores harum quod possimus nam quasi, vitae repudiandae
          voluptas veniam fugit neque beatae maxime, velit delectus repellat ab
          laudantium hic?
        </p>
      </div>
    </div>
  );
};

export default We;
